export default __webpack_public_path__ + "static/media/Notification.e976fc29.svg";